import { openInNewTab } from "../../../shared/utils/openInNewTab";
import { WS_LINKS } from "../../../types/wsLinks";

export const createHealthSherpaLink = (zipCode: string) =>
  "https://www.healthsherpa.com/marketplace/applicants?_agent_id=wingspan";

export const openMeridioGuidebook = () =>
  openInNewTab(WS_LINKS.meridioGuidebook);
